/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'

function BottomLink() {
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      pt={3}
    >
      {/* <Box
        mt={2}
        mb={2}
        width="100%"
        display="flex"
        justifyContent="center"
        flexDirection="row"
        alignItems="flex-end"
        whiteSpace="nowrap"
      >
         <Link
          className="link-light-text bullet-icon"
          target="_blank"
          to="https://www.excelhighschool.com/disclaimer.php"
        >
          {t('terms&Conditions')}
        </Link>
          <Link
          target="_blank"
          className="link-light-text"
          to="https://www.excelhighschool.com/privacy.php"
        >
          {t('privacyPolicy')}
        </Link>
      </Box>*/}
      <Typography align="center" component="p" variant="body2" color="textSecondary">
        {t('copyright', {
          year: t(new Date().getFullYear()),
        })}
      </Typography>
    </Box>
  )
}

export default BottomLink
